export default [
  {
    path: "/f7W2pk",
    children: [
      {
        path: "/Z32JgdPI1",
        name: "lgadoList",
        meta: {
          title: "Lga DOs",
          authRequired: true,
          acc: ["y27784"],
        },
        component: () => import("../views/lgado/list.vue"),
      },
      {
        path: "/iBlrDp37e/:tr?",
        name: "viewlgado",
        meta: {
          title: "View Lga DO",
          authRequired: true,
          acc: ["y74543"],
        },
        component: () => import("../views/lgado/view.vue"),
      },
      {
        path: "/UvZ3gpmmI/:tr?",
        name: "updatelgado",
        meta: {
          title: "Update Lga DO",
          authRequired: true,
          acc: ["y27487"],
        },
        component: () => import("../views/lgado/update.vue"),
      },
      {
        path: "/D3UdRPPgd/:tr?",
        name: "updatelgadoPassword",
        meta: {
          title: "Update Lga DO Password",
          authRequired: true,
          acc: ["y27487"],
        },
        component: () => import("../views/lgado/updatePassword.vue"),
      },
      {
        path: "/U74KKEp/:tr?",
        name: "updatelgadoRole",
        meta: {
          title: "Update Lga DO Role",
          authRequired: true,
          acc: ["y27487"],
        },
        component: () => import("../views/lgado/updateRole.vue"),
      },
      {
        path: "/eGprQFnI",
        name: "newlgado",
        meta: {
          title: "New Lga DO",
          authRequired: true,
          acc: ["y46585"],
        },
        component: () => import("../views/lgado/new.vue"),
      },
      {
        path: "/eGpr0839b384787c09663dcf7208QFnI",
        name: "assign.lga.officer",
        meta: {
          title: "Assign Lga DO",
          authRequired: true,
          acc: ["y83348"],
        },
        component: () => import("../views/lgado/assign.vue"),
      },
      {
        path: "/eGp0876027710416045cfd87396FnI",
        name: "assigned.lga.officer",
        meta: {
          title: "Assigned Lga DO",
          authRequired: true,
          acc: ["y10235"],
        },
        component: () => import("../views/lgado/assigned.vue"),
      },
    ],
  },
];
